module.exports = __webpack_public_path__ + "static/img/success.644acaf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/success.svg
// module id = Et7L
// module chunks = 1 2